import React from 'react';
import {
  Button,
} from 'reactstrap';
import SkipBankingSurvey from '../SkipBankingSurvey';
import Wordings from '../../../config/stringTable';

export default function SkipBankingButtonView(props) {
  if (!props.skipBankingSurvey?.enabled
    || !props.skipBankingSurvey.answers) return null;

  const { clientId, requestId, language = 'en' } = props;
  const isHidden = !props.showButton || props.skipBankingSurvey.style === 'hidden';

  return (
    <>
      { !isHidden && (
        <Button
          id="skipBankingButton"
          data-cy="skipBanking"
          color="link"
          onClick={props.onSkipButtonClick}
        >
          { Wordings[language]['Skip banking data'] }
        </Button>
      )}
      <SkipBankingSurvey
        clientId={clientId}
        requestId={requestId}
        skipBankingSurvey={props.skipBankingSurvey}
        isOpen={props.isOpen}
        onClose={props.onSkipBanking}
        allowEmptyResponse={false}
      />
    </>
  );
}
